// 表单样式通用

export default {
  data() {
    return {
      rowHeight: 12,
      margin: [10, 10]
    }
  },
  methods: {
    hasTips(tip) {
      if (tip) {
        return true
      } else {
        return false
      }
    },
    nameStyle(tip) {
      const lh = this.hasTips(tip) ? '24px' : '44px'
      return {
        'line-height': lh
      }
    }
  }
}
